export const commonConstants = {
  GET_AUTOCOMPLETE_REQUEST: 'GET_AUTOCOMPLETE_REQUEST',
  GET_AUTOCOMPLETE_SUCCESS: 'GET_AUTOCOMPLETE_SUCCESS',
  GET_AUTOCOMPLETE_FAILURE: 'GET_AUTOCOMPLETE_FAILURE',
};
